import { supabase } from "../../config/supabase";

 // Create a challenge
 const createChallenge = async (title = '',description = '',duration = 7,missionId = 1,ratings,views_limit) => {
    const newChallenge = { 
        title:title.toLowerCase(),
        description:description.toLowerCase(),
        duration,
        ratings,
        views_limit
    };
    try {
        const { data,error } = await supabase.from('challenges').insert([newChallenge]).select("challenge_id");
        if (error) throw new Error(error);

        const linkMissionToChallenge = {
            challenge_id:data[0].challenge_id,
            mission_id:missionId
        }
        const linkedMission = await supabase.from('missions_challenges').insert([linkMissionToChallenge]);
        if (linkedMission.error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in creating challenges:',err);
        return { error: err };
    }
};

export { createChallenge };